export const BRAND_COLOR = "#ff8038";
export const BRAND_HOVER_COLOR = "#e6722f";
